import { Form, Button } from "react-bootstrap";
import { useState } from "react";

const usersList = [
  { name: "Michael Walker", img: "/assets/img/profiles/avatar-01.jpg" },
  { name: "Sophie Headrick", img: "/assets/img/profiles/avatar-02.jpg" },
  { name: "Cameron Drake", img: "/assets/img/profiles/avatar-03.jpg" },
  { name: "Doris Crowley", img: "/assets/img/profiles/avatar-04.jpg" },
  { name: "Thomas Bordelon", img: "/assets/img/profiles/avatar-05.jpg" },
];

const EditAccessTab = () => {
  const [visibility, setVisibility] = useState("select");
  const [selectedUsers, setSelectedUsers] = useState([]);

  const toggleUser = (name) => {
    setSelectedUsers((prev) =>
      prev.includes(name)
        ? prev.filter((u) => u !== name)
        : [...prev, name]
    );
  };

  return (
    <>
      <div className="access-tab">

        {/* VISIBILITY */}
        <Form.Label>Visibility</Form.Label>
        <div className="radio-group">
          <Form.Check
            type="radio"
            label="Public"
            name="visibility"
            checked={visibility === "public"}
            onChange={() => setVisibility("public")}
          />
          <Form.Check
            type="radio"
            label="Private"
            name="visibility"
            checked={visibility === "private"}
            onChange={() => setVisibility("private")}
          />
          <Form.Check
            type="radio"
            label="Select People"
            name="visibility"
            checked={visibility === "select"}
            onChange={() => setVisibility("select")}
          />
        </div>

        {/* USERS LIST */}
        {visibility === "select" && (
          <div className="user-box mt-3">
            {usersList.map((user, i) => (
              <div key={i} className="user-item">
                <Form.Check
                  type="checkbox"
                  checked={selectedUsers.includes(user.name)}
                  onChange={() => toggleUser(user.name)}
                />
                <img src={user.img} alt="" />
                <span>{user.name}</span>
              </div>
            ))}

            <div className="text-center mt-3">
              <Button className="btn-orange btn-sm">
                Confirm
              </Button>
            </div>
          </div>
        )}

        {/* STATUS */}
        <Form.Group className="mt-4">
          <Form.Label>Status</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
            <option>Active</option>
            <option>Inactive</option>
          </Form.Select>
        </Form.Group>

      </div>

      {/* STYLES */}
      <style>{`
        .access-tab {
          padding: 5px;
        }

        /* RADIO */
        .radio-group {
          display: flex;
          gap: 20px;
          margin-top: 5px;
        }

        .form-check-input:checked {
          background-color: #ff6b2c;
          border-color: #ff6b2c;
        }

        /* USER BOX */
        .user-box {
          background: #f9fafb;
          padding: 15px;
          border-radius: 8px;
        }

        .user-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 0;
        }

        .user-item img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }

        /* BUTTON */
        .btn-orange {
          background: #ff6b2c;
          border: none;
          color: white;
        }

        .btn-orange:hover {
          background: #e65a1f;
        }

        /* SELECT */
        .custom-select:focus {
          border-color: #ff6b2c;
          box-shadow: 0 0 0 0.2rem rgba(255,107,44,0.2);
        }

        option:checked {
          background: #ff6b2c;
          color: white;
        }

        /* MOBILE */
        @media(max-width:768px){
          .radio-group {
            flex-direction: column;
            gap: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default EditAccessTab;